import { Box, Text } from '@wix/design-system';
import {
  STUDIO_NEW_BADGE_BG_COLOR,
  useIsStudioNewUi,
} from '@wix/package-picker-shared-studio';
import classNames from 'classnames';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import styles from './FeaturesGridNewBadge.scss';

const NEW_BADGE_BG = '#E5E8FF';

interface FeaturesGridNewBadgeProps {
  upperCase?: boolean;
  dataHook?: string;
}

export const FeaturesGridNewBadge = ({
  upperCase = true,
  dataHook,
}: FeaturesGridNewBadgeProps) => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const isStudioNewUi = useIsStudioNewUi();

  const text = upperCase
    ? t('features.new_feature.new_badge').toUpperCase()
    : t('features.new_feature.new_badge');

  return (
    <Box
      backgroundColor={isStudioNewUi ? STUDIO_NEW_BADGE_BG_COLOR : NEW_BADGE_BG}
      borderRadius="4px"
      padding="0 6px"
      height="18px"
      dataHook={dataHook}
    >
      <Text
        size="tiny"
        skin="standard"
        weight="bold"
        className={classNames(styles.newBadge, {
          [styles.highlightNewBadge]: isStudioNewUi,
        })}
      >
        {text}
      </Text>
    </Box>
  );
};
